export function googleLanguageFor(user: {role?: string; normalized_position?: string | null; normalized_positions?: string[]} | null, preferred: string): 'en' | 'ru' {
  const positions = [user?.normalized_position, ...(user?.normalized_positions || [])]
  return user?.role === 'employee' && positions.includes('Google') ? 'en' : preferred === 'ru' ? 'ru' : 'en'
}
